import { FC, useContext } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { BookContext } from "../../contexts/BookContext";

type Props = {
  chapterNumber: number;
  onAnecdotesClick?: () => void;
};

export const GeneratedChapterTableActionsButton: FC<Props> = ({
  chapterNumber,
  onAnecdotesClick,
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const handleNavigate = () => {
    if (isDisabled) return;

    navigate(`/generated_chapter/${chapterNumber}/`);
  };
  const bookContext = useContext(BookContext);
  const status = bookContext?.book?.status;
  const statusToDisable = ["pdf_generating", "pdf_generated"];
  const isDisabled = status && statusToDisable.includes(status);

  return (
    <div className="flex gap-2 justify-end">
      <button
        type="button"
        className="px-6 py-1 inline-flex text-l leading-5 font-normal rounded-full border-2 border-herb-50 hover:bg-herb-10 text-herb-700"
        onClick={onAnecdotesClick}
      >
        Témoignages
      </button>
      <button
        type="button"
        className="px-6 py-1 inline-flex text-l leading-5 font-normal rounded-full border-2 border-delicate-50 hover:bg-delicate-10 text-delicate-700"
        onClick={() => handleNavigate()}
        disabled={isDisabled}
      >
        {t("generatedChapter.reread")}
      </button>
    </div>
  );
};
